import { render, staticRenderFns } from "./CartaoDeJustificativaDeCancelamento.vue?vue&type=template&id=61e750c4&scoped=true"
import script from "./CartaoDeJustificativaDeCancelamento.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoDeJustificativaDeCancelamento.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoDeJustificativaDeCancelamento.vue?vue&type=style&index=0&id=61e750c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e750c4",
  null
  
)

export default component.exports